export function getOrganizationSchema(baseUrl) {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Schnerp",
    url: baseUrl,
    logo: `${baseUrl}/logo/schnerp_symbol@4x.png`,
    contactPoint: {
      "@type": "ContactPoint",
      email: "help@schnerp.com",
      contactType: "customer support",
    },
  };
}

export function getFaqPageSchema(questions) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: questions.map(({ question, answer }) => ({
      "@type": "Question",
      name: question,
      acceptedAnswer: {
        "@type": "Answer",
        text: answer,
      },
    })),
  };
}

export function getBlogPostingSchema({
  title,
  excerpt,
  publishedAt,
  updatedAt,
  author,
  url,
  image,
}) {
  return {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    headline: title,
    description: excerpt,
    datePublished: publishedAt,
    ...(updatedAt && { dateModified: updatedAt }),
    url,
    ...(image && { image }),
    author: {
      "@type": "Person",
      name: author?.name || "Schnerp Team",
    },
    publisher: {
      "@type": "Organization",
      name: "Schnerp",
    },
  };
}
